export const headline =
  'text-36 tracking-0 leading-44 text-black md:text-60 md:tracking-0 md:leading-72'
export const link = 'text-14 font-Roboto tracking-0 leading-12 uppercase'
export const imageClassName = 'moodBoardImg'
export const linkedImage = 'hover:scale-110 transition-all duration-300'
